module.exports = __webpack_public_path__ + "09_face.2b28a6c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer1/09_face.png
// module id = IMY7
// module chunks = 0